import gql from 'graphql-tag'

export const GET_CUT_OFF_ENGINES = gql`
  query CutoffEngines($filter: GetCutOffEnginesFilter) {
    cutoffEngines(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      cutOffEngines {
        data {
          vehicle {
            licensePlate
            vehicle2Vgroup {
              vgroup {
                name
              }
            }
            id
          }
          operationTime {
            mon {
              startTime
              endTime
            }
            tue {
              startTime
              endTime
            }
            wed {
              startTime
              endTime
            }
            thu {
              startTime
              endTime
            }
            fri {
              startTime
              endTime
            }
            sat {
              startTime
              endTime
            }
            sun {
              startTime
              endTime
            }
          }
          isActive
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
        ids
      }
    }
  }
`

export const GET_CUT_OFF_ENGINE = gql`
  query CutOffEngine($filter: GetCutOffEngineFilter) {
    cutOffEngine(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      cutOffEngine {
        vehicle {
          id
          licensePlate
        }
        operationTime {
          mon {
            startTime
            endTime
          }
          tue {
            startTime
            endTime
          }
          wed {
            startTime
            endTime
          }
          thu {
            startTime
            endTime
          }
          fri {
            startTime
            endTime
          }
          sat {
            startTime
            endTime
          }
          sun {
            startTime
            endTime
          }
        }
        isActive
      }
    }
  }
`

export const UPSERT_CUT_OFF_ENGINE = gql`
  mutation UpsertCutOffEngine($input: UpsertCutOffEngineInput!) {
    upsertCutOffEngine(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      upsertCutOffEngine {
        vehicle {
          id
        }
        isActive
      }
    }
  }
`

export const BULK_UPDATE_CUT_OFF_ENGINES = gql`
  mutation UpdateCutOffEngines($input: UpdateCutOffEnginesInput!) {
    updateCutOffEngines(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateCutOffEngines {
        vehicleIds
        isActive
        isResetSchedule
      }
    }
  }
`

export const IMPORT_CUT_OFF_ENGINES = gql`
  mutation ImportCutOffEngines($input: ImportCutOffEngineInput!) {
    importCutOffEngines(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      importCutOffEngines {
        totalData
        totalSuccess
        totalFailed
        originalFile
        successFile
        errorFile
      }
    }
  }
`

export const EXPORT_CUT_OFF_ENGINE = gql`
  query ExportCutOffEngine {
    exportCutOffEngine {
      isSuccessful
      errorCode
      errorName
      message
      status
      exportCutOffEngine {
        base64
      }
    }
  }
`

export const GET_CUT_OFF_ENGINE_UPLOAD_HISTORY = gql`
  query ImportHistory($filter: ImportHistoriesFilter) {
    importHistory(filter: $filter) {
      isSuccessful
      message
      importHistory {
        filename
        importOn
        model
        totalFailed
        totalSuccess
        users {
          fullname
        }
      }
    }
  }
`

export const GET_CUT_OFF_ENGINE_HISTORY = gql`
  query CutOffEngineHistories($filter: GetCutOffEngineHistoriesFilter) {
    cutOffEngineHistories(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      cutOffEngineHistories {
        vehicle {
          licensePlate
          id
        }
        geofenceId
        geofenceName
        latitude
        longitude
        status
        createdOn
      }
    }
  }
`
